import Vue from 'vue'
import Router from 'vue-router'

import Dashboard from '../views/Dashboard'
import Configuration from '../views/Configuration'
import Transfer from '../views/Transfer'
import Login from '../views/Login'
import Profile from '../views/Profile'
import SimUsage from '../views/SimUsage'
import ApiService from '../utils/apiService'

import { AuthService } from '../utils/authService'
import userStore from '../store/modules/userStore'
import stores from '../store/index'

import { ROUTERS } from './routerConfiguration'

Vue.use(Router)
const routerInstance = new Router({
  mode: 'history',
  base: typeof window !== 'undefined' ? window.env.BASE_URL : 'default_value',
  routes: [
    {
      path: '/',
      component: Dashboard,
      ...ROUTERS.dashboard
    },
    {
      path: '/profile',
      component: Profile,
      ...ROUTERS.profile
    },
    {
      path: '/configuration',
      component: Configuration,
      ...ROUTERS.configuration,
      beforeEnter: (to, from, next) => {
        if (userStore.state.role !== 'Internal-adm') {
          return next({ name: 'dashboard' })
        }
        next()
      }
    },
    {
      path: '/transfer',
      component: Transfer,
      ...ROUTERS.transfer
    }, 
    {
      path: '/login',
      component: Login,
      ...ROUTERS.login
    },
    {
      path: '/sim_usage',
      component: SimUsage,
      ...ROUTERS.sim_usage
    }, 
  ],
  scrollBehavior(to, from, savedPosition) {
    // Always scroll to the top of the page.
    return { x: 0, y: 0 };
  }
})

routerInstance.beforeEach((to, from, next) => {
  if (to.name === 'login') {
    next()
  } else if (to.fullPath.includes('code')) {
    AuthService.mgr.signinRedirectCallback().then(async function (user) {
      await loadAsync()
      next({ name: 'dashboard' })
    }).catch(function (err) {
      console.log(err)
      AuthService.signOut()
      next({ name: 'login' })
    })
  } else {
    AuthService.getSignedIn().then(
      async function (signIn) {
        if (!signIn) {
          return next({ name: 'login' })
        } else {
          await loadAsync()
          next()
        }
      },
    err => {
      console.log(err)
    })
  }
})

function ip () {
  return new Promise((resolve, reject) => {
    ApiService
      .get('/ip').then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

async function loadAsync () {
  return new Promise( async function (resolve, reject) {
    await stores.dispatch('userStore/loadToken')
    await stores.dispatch('userStore/loadTokenId')
    await stores.dispatch('userStore/loadUserInfo')
    resolve(true)
  })
}

export default routerInstance
